<template>
  <div>
    <div v-if="loaded" class="row" style="padding-bottom:10px">
      <div class="col-md-12">
        <div class="checkbox-wrapper-14">
          <input @change="updateEventParameter" v-model="event_parameter.active" id="s1-14" type="checkbox" class="switch">
          <label style="font-size:15px" for="s1-14">Calcular Duração do Evento Automaticamente</label>
        </div>
        <div v-if="!event_parameter.active" style="margin-left:15px">
          <label style="font-size:13px">Tempo padrão a ser exibido:</label>
          <input @change="updateEventParameter" v-model="event_parameter.default_time" type="time" step="1" class="form-control" style="width:120px">
        </div>
        
      </div>
    </div>
    <div v-if="loaded" class="row" style="padding-bottom:10px">
      <div class="col-md-12">
        <div class="checkbox-wrapper-14">
          <input @change="sendCaptureEmotion()" v-model="event_parameter.capture_emotion" id="s1-14" type="checkbox" class="switch">
          <label style="font-size:15px" for="s1-14">Módulo Emociograma</label>
        </div>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      loaded: false,
      event_parameter: {
        active:false,
        capture_emotion: false,
      }

    }
  },
  methods: {
    sendCaptureEmotion(){
      const self = this;
      const api = self.$store.state.api + "event_parameters/1"

      this.event_parameter.capture_emotion = this.event_parameter.capture_emotion ? 1 : 0;

      self.$http
        .put(api, { 'active' : this.event_parameter.active, 'default_time' : this.event_parameter.default_time , 'capture_emotion' : this.event_parameter.capture_emotion })
        .then((response) => {
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao salvar o parâmetro");
        });
    },
    updateEventParameter(){
      const self = this;
      const api = self.$store.state.api + "event_parameters/1"

      this.event_parameter.capture_emotion = this.event_parameter.capture_emotion ? 1 : 0;

      self.$http
        .put(api, { 'active' : this.event_parameter.active, 'default_time' : this.event_parameter.default_time , 'capture_emotion' : this.event_parameter.capture_emotion })
        .then((response) => {
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao salvar o parâmetro");
        });
    },
    getEventParameter() {
      const self = this;
      const api = self.$store.state.api + "event_parameters"

      self.$http
        .get(api)
        .then((response) => {
          self.event_parameter = response.data.data[0];
          self.event_parameter.capture_emotion = self.event_parameter['capture_emotion'];
      
          self.loaded = true;
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
    },    
  },
  mounted(){
    this.getEventParameter();
  },
  components: {
  }
};
</script>

<style scoped>
  @supports (-webkit-appearance: none) or (-moz-appearance: none) {
    .checkbox-wrapper-14 input[type=checkbox] {
      --active: #275EFE;
      --active-inner: #fff;
      --focus: 2px rgba(39, 94, 254, .3);
      --border: #BBC1E1;
      --border-hover: #275EFE;
      --background: #fff;
      --disabled: #F6F8FF;
      --disabled-inner: #E1E6F9;
      -webkit-appearance: none;
      -moz-appearance: none;
      height: 21px;
      outline: none;
      display: inline-block;
      vertical-align: top;
      position: relative;
      margin: 0;
      cursor: pointer;
      border: 1px solid var(--bc, var(--border));
      background: var(--b, var(--background));
      transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    }
    .checkbox-wrapper-14 input[type=checkbox]:after {
      content: "";
      display: block;
      left: 0;
      top: 0;
      position: absolute;
      transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
    }
    .checkbox-wrapper-14 input[type=checkbox]:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: .3s;
      --d-t: .6s;
      --d-t-e: cubic-bezier(.2, .85, .32, 1.2);
    }
    .checkbox-wrapper-14 input[type=checkbox]:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: 0.9;
    }
    .checkbox-wrapper-14 input[type=checkbox]:disabled:checked {
      --b: var(--disabled-inner);
      --bc: var(--border);
    }
    .checkbox-wrapper-14 input[type=checkbox]:disabled + label {
      cursor: not-allowed;
    }
    .checkbox-wrapper-14 input[type=checkbox]:hover:not(:checked):not(:disabled) {
      --bc: var(--border-hover);
    }
    .checkbox-wrapper-14 input[type=checkbox]:focus {
      box-shadow: 0 0 0 var(--focus);
    }
    .checkbox-wrapper-14 input[type=checkbox]:not(.switch) {
      width: 21px;
    }
    .checkbox-wrapper-14 input[type=checkbox]:not(.switch):after {
      opacity: var(--o, 0);
    }
    .checkbox-wrapper-14 input[type=checkbox]:not(.switch):checked {
      --o: 1;
    }
    .checkbox-wrapper-14 input[type=checkbox] + label {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      margin-left: 4px;
    }

    .checkbox-wrapper-14 input[type=checkbox]:not(.switch) {
      border-radius: 7px;
    }
    .checkbox-wrapper-14 input[type=checkbox]:not(.switch):after {
      width: 5px;
      height: 9px;
      border: 2px solid var(--active-inner);
      border-top: 0;
      border-left: 0;
      left: 7px;
      top: 4px;
      transform: rotate(var(--r, 20deg));
    }
    .checkbox-wrapper-14 input[type=checkbox]:not(.switch):checked {
      --r: 43deg;
    }
    .checkbox-wrapper-14 input[type=checkbox].switch {
      width: 38px;
      border-radius: 11px;
    }
    .checkbox-wrapper-14 input[type=checkbox].switch:after {
      left: 1px;
      top: 1px;
      border-radius: 50%;
      width: 17px;
      height: 17px;
      background: var(--ab, var(--border));
      transform: translateX(var(--x, 0));
    }
    .checkbox-wrapper-14 input[type=checkbox].switch:checked {
      --ab: var(--active-inner);
      --x: 17px;
    }
    .checkbox-wrapper-14 input[type=checkbox].switch:disabled:not(:checked):after {
      opacity: 0.6;
    }
  }

  .checkbox-wrapper-14 * {
    box-sizing: inherit;
  }
  .checkbox-wrapper-14 *:before,
  .checkbox-wrapper-14 *:after {
    box-sizing: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parameters/Parameters.vue